export default __webpack_public_path__ + "static/media/portfolio-4.d71b23f6.jpg";